import React from 'react'
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useTranslation } from 'react-i18next';

function CheckoutSteps({ step1, step2, step3, step4, step5 }) {
    const { t } = useTranslation();
    return (

        <Nav className='justify-content-center mb-4'>
            <Nav.Item>
                {step1 ? (
                    <LinkContainer to='/login'>
                        <Nav.Link>{t('checkoutSteps.signIn')}</Nav.Link>
                    </LinkContainer>
                ) : (
                    <Nav.Link disabled>{t('checkoutSteps.signIn')}</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step2 ? (
                    <LinkContainer to='/shipping'>
                        <Nav.Link>{t('checkoutSteps.shipping')}</Nav.Link>
                    </LinkContainer>
                ) : (
                    <Nav.Link disabled>{t('checkoutSteps.shipping')}</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step3 ? (
                    <LinkContainer to='/payment'>
                        <Nav.Link>{t('checkoutSteps.payment')}</Nav.Link>
                    </LinkContainer>
                ) : (
                    <Nav.Link disabled>{t('checkoutSteps.payment')}</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step4 ? (
                    <LinkContainer to='/placeorder'>
                        <Nav.Link>{t('checkoutSteps.placeOrder')}</Nav.Link>
                    </LinkContainer>
                ) : (
                    <Nav.Link disabled>{t('checkoutSteps.placeOrder')}</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step5 ? (
                    <LinkContainer to='/genai/create_story'>
                        <Nav.Link>{t('checkoutSteps.createBook')}</Nav.Link>
                    </LinkContainer>
                ) : (
                    <Nav.Link disabled>{t('checkoutSteps.createBook')}</Nav.Link>
                )}
            </Nav.Item>
        </Nav>
    );
}   

export default CheckoutSteps
